import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import { getEnrollmentHistoryUrl } from 'automation-ui-canvas/utils/urls';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { useShowNonMarketingStatus } from 'automation-ui-management/hooks/authHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuccessfulEnrollmentRow = ({
  flow,
  enrollmentInfo
}) => {
  const history = useHistory();
  const {
    search
  } = useLocation();
  const trackEvent = useTrackEvent();
  const showNonMarketingStatus = useShowNonMarketingStatus(flow.objectTypeId);
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const {
    enrollmentId,
    objectId,
    enrollmentTimestamp
  } = enrollmentInfo;
  const handleEnrollmentClick = () => {
    searchParams.set('enrollmentId', enrollmentId.toString());
    // TODO: currently changed to enrollment-history for v1. Update once we start working on v2.
    history.replace({
      pathname: getEnrollmentHistoryUrl({
        flowId: flow.flowId
      }),
      search: searchParams.toString()
    });
  };
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx(UITableHoverCell, {
      hoverContent: /*#__PURE__*/_jsx(UITableHoverContent, {
        children: /*#__PURE__*/_jsx(TrackableButton, {
          size: "extra-small",
          use: "tertiary-light",
          onClick: () => {
            handleEnrollmentClick();
          },
          trackableKey: Trackables.PERFORMANCE_HISTORY_CLICKED_VIEW_ENROLLMENT,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentHistory.panel.enrollment-list.table.viewEnrollment"
          })
        })
      }),
      className: 'p-left-10',
      tooltip: false,
      children: /*#__PURE__*/_jsx(UIFlex, {
        direction: "column",
        children: /*#__PURE__*/_jsx(UILink, {
          onClick: () => {
            handleEnrollmentClick();
            trackEvent(Trackables.PERFORMANCE_HISTORY_CLICKED_VIEW_ENROLLMENT);
          },
          children: getIsObjectlessFlow(flow) ? /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "automation.enrollmentHistory.panel.enrollment-list.table.workflowRun",
            options: {
              date: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
                value: enrollmentTimestamp,
                useMultiline: false,
                format: "l LT"
              })
            }
          }) : /*#__PURE__*/_jsx(ObjectNameReference, {
            id: objectId,
            objectTypeId: flow.objectTypeId,
            showNonMarketingStatus: showNonMarketingStatus,
            showMergeStatus: true,
            mergeAuditCutoff: enrollmentTimestamp,
            disableTruncateString: false,
            href: null
          })
        })
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
        value: enrollmentTimestamp,
        useMultiline: true
      })
    })]
  });
};
export default SuccessfulEnrollmentRow;